export enum PlanStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Grandfathered = 'Grandfathered',
  Draft = 'Draft',
  Membership = 'Membership',
  PaidInFull = 'Paid in Full',
  Challenge = 'Challenge',
  Frozen = 'Frozen',
  Free = 'Free',
  SessionPacks = 'Session Packs',
}

export enum PlanType {
  PersonalTraining = 'Personal Training',
  OpenGym = 'Open Gym',
  SemiPrivate = 'Semi-private',
  LargeGroup = 'Large Group',
  Other = 'Other',
}

export enum BillingType {
  PaidInFull = 'Paid in Full',
  Recurring = 'Recurring',

  ClassOrSessionPacks = 'Session packs',
  Free = 'Free',
}
export const BillingTypeIds = {
  [BillingType.Recurring]: 1,
  [BillingType.PaidInFull]: 2,
  [BillingType.ClassOrSessionPacks]: 3,
  [BillingType.Free]: 4,
};

export enum PaymentStatus {
  Current = 'Current',
  Successful = 'Successful',
  Failed = 'Failed',
  PastDue = 'Past Due',
  NoneOnFile = 'None on file',
  Comped = 'Comped',
  Refunded = 'Refunded',
  Forgiven = 'Forgiven',
  PaidToDate = 'Paid to Date',
  Cancelled = 'Cancelled',
  Pending = 'Pending',
}

export enum InvoiceStatus {
  Pending = 'Pending',
  Paid = 'Paid',
  PastDue = 'Past Due',
  Void = 'Void',
  Voided = 'Voided',
  Posted = 'Posted',
}

export enum PaymentHistoryStatus {
  Queued = 'Queued',
  Approved = 'Approved',
  Processing = 'Processing',
  Processed = 'Processed',
  Funded = 'Funded',
  Failed = 'Failed',
  Refunded = 'Refunded',
  Forgiven = 'Forgiven',
  Cancelled = 'Cancelled',
}

export type PaymentHistoryDisplayStatus = 'Pending' | 'Processed' | 'Failed' | 'Cancelled';

export const PaymentHistoryStatusMap: Record<PaymentHistoryStatus, PaymentHistoryDisplayStatus> = {
  [PaymentHistoryStatus.Approved]: 'Pending',
  [PaymentHistoryStatus.Processing]: 'Pending',
  [PaymentHistoryStatus.Processed]: 'Processed',
  [PaymentHistoryStatus.Funded]: 'Processed',
  [PaymentHistoryStatus.Failed]: 'Failed',
  [PaymentHistoryStatus.Refunded]: 'Processed',
  [PaymentHistoryStatus.Cancelled]: 'Cancelled',
  [PaymentHistoryStatus.Forgiven]: 'Processed',
  [PaymentHistoryStatus.Queued]: 'Pending',
} as const;

export enum MembershipStatus {
  Active = 'Active',
  Frozen = 'Frozen',
  Cancelled = 'Cancelled',
  EndingSoon = 'Ending Soon',
  NotStarted = 'Not Started',
}

export enum MembershipStatusTypeId {
  Active = 1,
  Cancelled = 2,
  Frozen = 3,
  Renewed = 4,
  NotStarted = 5,
}

export enum ActiveMembershipTypes {
  FullMembership = 'Full Membership',
  LimitedTimePass = 'Limited Time Pass',
  Challenger = 'Challenge',
  None = 'None',
}

export enum ContactType {
  Lead = 'Lead',
  Client = 'Client',
  Frozen = 'Frozen',
  Exited = 'Exited',
}

export enum ContactStatus {
  OTHER = 'Other',
}

export enum LocationType {
  Physical = 'Physical',
  Virtual = 'Virtual',
  Both = 'Both',
}

export const LocationTypeIds = {
  [LocationType.Physical]: 1,
  [LocationType.Virtual]: 2,
  [LocationType.Both]: 3,
};

export enum GymType {
  Other = 'Other',
  HealthClub = 'Health Club',
  GroupTrainingOnly = 'Group Training Only',
  SemiPrivate = 'Semi Private',
  PersonalTraining = 'Personal Training',
  MartialArts = 'Martial Arts',
  SpinStudio = 'Spin Studio',
  YogaPilates = 'Yoga/Pilates',
}
export const GymTypeIds = {
  [GymType.Other]: 1,
} as const;

export enum ClassType {
  Bootcamp = 'Bootcamp',
  Boxing = 'Boxing / Kickboxing',
  Cardio = 'Cardio',
  Crossfit = 'Crossfit',
  Hiit = 'HIIT',
  MartialArts = 'Martial Arts',
  SemiPrivate = 'Semi-Private',
  Spinning = 'Spinning',
  StrengthTraining = 'Strength Training',
  YogaPilates = 'Yoga / Pilates',
}

export enum PlanDate {
  Frozen = 'Frozen',
  Cancelled = 'Cancelled',
  AutoRenewal = 'AutoRenewal',
}
